import { defineStore, mapActions } from "pinia";
import { useAxiosStore } from "js/stores/axiosStore.js";

const REFRESH_INTERVAL = 1000 * 60 * 10;

export const useUserStore = defineStore("userStore", {
    state: () => {
        return {
            isLoggedIn: window.tripper.isLoggedIn,
            justRegistered: false,
            user: {
                id: undefined,
                name: undefined,
                currency: undefined,
                geo: undefined,
                preferences: {
                    track_trip_expenses: false,
                    track_location_expenses: false,
                    track_mot: false,
                    notification_emails: true,
                },
                isVerified: Boolean(window.tripper.isVerified),
            },
            friends: null,
            unreadNotifications: 0,
        };
    },
    actions: {
        update(user) {
            this.user = user;
        },
        async getFriends(refresh) {
            if (this.friends === null || refresh) {
                this.friends = await this.fetch("/api/user/friends");
            }
            return this.friends;
        },
        getUnreadNotifications() {
            return this.unreadNotifications;
        },
        async init() {
            if (!this.isLoggedIn) {
                return false;
            }
            if (this.user.id !== undefined) {
                this.refreshNotifications();
                return true;
            }
            return this.refreshUser();
        },
        async refreshUser() {
            return this.fetch("/api/user")
                .then((user) => {
                    this.update(user);
                    this.isLoggedIn = true;
                    this.justRegistered = false;
                    this.refreshNotifications();
                    return true;
                })
                .catch((err) => {
                    if (err.response?.status !== 401) {
                        throw err;
                    }
                    this.isLoggedIn = false;
                    this.user.isVerified = false;
                    return false;
                });
        },
        async refreshCSRF() {
            this.fetch("/sanctum/csrf-cookie");
        },
        async refreshNotifications(num) {
            if (num !== undefined) {
                this.unreadNotifications = 0;
                return;
            }
            return this.fetch("/api/invitations?count-unread").then((count) => {
                this.unreadNotifications = count;
            });
        },
        setRoutine() {
            return setInterval(() => {
                this.refreshCSRF();
                if (this.isLoggedIn) {
                    this.refreshNotifications();
                } else {
                    this.refreshUser();
                }
            }, REFRESH_INTERVAL);
        },
        async login(email, password) {
            return await this.create("/api/login", { email, password });
        },
        async logout() {
            return await this.create("/api/logout")
                .then(() => {
                    this.$reset();
                    this.isLoggedIn = false;
                    this.user.isVerified = false;
                    return true;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        ...mapActions(useAxiosStore, ["fetch", "create", "edit", "delete"]),
    },
});
